import React, { useState } from 'react';

import { Button, Modal, Card, Result } from 'antd';
import { IInvoice } from 'types/types';
import { Price } from 'components/Display';

interface IProps {
    data: IInvoice | undefined;
    /** The actual amount charged (may differ from total_with_shipping when a
     *  partial payment already exists in Zoho). Defaults to total_with_shipping. */
    chargeAmount?: number;
}

const PaymentConfirmed: React.FC<IProps> = props => {
    const [visible, setVisible] = useState<boolean>(true);

    const { data, chargeAmount } = props;

    const totalPaid =
        chargeAmount ?? data?.total_with_shipping ??
        (Number(data?.grand_total ?? 0) + Number(data?.shipping_cost ?? 0));

    return (
        <>
            <Modal
                open={visible}
                title="Payment Confirmed!"
                onOk={() => setVisible(false)}
                onCancel={() => setVisible(false)}
                width={600}
                // wrapClassName="w-2/5"
                footer={[
                    <Button
                        type="primary"
                        key="console"
                        data-testid="testButton"
                        className="mt-5"
                        onClick={() => setVisible(false)}
                    >
                        Close
                    </Button>,
                ]}
            >
                <Result
                    status="success"
                    title="Thank You for Your Payment!"
                    subTitle="A Receipt for this transaction has been sent via email for you records."
                    style={{ overflowY: 'auto', overflowX: 'auto', height: '58vh' }}
                >
                    <>
                        <p key="TitleProducts" className="font-bold text-lg mt-2 text-center">
                            Products
                        </p>

                        {data?.line_items.map(item => {
                            return (
                                <Card className="mt-2 text-left rounded-lg" key={item.id}>
                                    <span className="font-bold ">Product Name: </span>
                                    <span>{item.name}</span>
                                    <br></br>
                                    <span className="font-bold">Quantity: </span>

                                    <span>{item.quantity}</span>
                                    <br></br>

                                    <span className="font-bold">Total price: </span>
                                    <span>
                                        <Price style={{ fontSize: '14px' }} value={item.total ?? 0} />
                                    </span>
                                </Card>
                            );
                        })}

                        {Number(data?.shipping_cost ?? 0) > 0 && (
                            <Card className="mt-2 text-left rounded-lg" key="shipping">
                                <span className="font-bold">Product Name: </span>
                                <span>Shipping</span>
                                <br />
                                <span className="font-bold">Quantity: </span>
                                <span>1</span>
                                <br />
                                <span className="font-bold">Total price: </span>
                                <span>
                                    <Price style={{ fontSize: '14px' }} value={Number(data?.shipping_cost ?? 0)} />
                                </span>
                            </Card>
                        )}

                        <p className="font-bold text-sm mt-3 text-center">Total Payment Amount</p>
                        <div className="font-bold text-lg text-center">
                            <Price
                                style={{ fontSize: '24px' }}
                                value={totalPaid}
                            />
                        </div>
                    </>
                </Result>
            </Modal>
        </>
    );
};

export default PaymentConfirmed;
